const colors = [
    "rgba(125, 230, 219, 1)",
    "rgba(255, 152, 152, 1)",
    "rgba(88, 218, 148, 1)",
    "rgba(255, 136, 173, 1)",
    "rgba(228, 228, 228, 1)",
]

exports.randomColor = () => colors[Math.floor(Math.random() * colors.length)]